<template>
    <div v-show="visible">
        <el-dialog title="流程跟踪-审批信息" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="500">    
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="checkName" label="审核人" width="100"></el-table-column>
                <el-table-column prop="checkTime" label="审核日期" width="100"></el-table-column>
                <el-table-column prop="checkRemark" label="审核意见" ></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http';
    import {banBackSpace} from '../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    leaveId:"",
                },
                data:[]
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            indexMethod(index) {
                return (index+1);
            },
            init(data){
                this.visible=true;
                this.form.leaveId=data.id;
                this.getData();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                let url= this.leaveFlowtUrl;
                let data = {
                    leaveId:this.form.leaveId,
                };
                // console.log(JSON.stringify(data));
                this.apiPost(url, data).then((res) => {
                    if(res.status == 200){
                        this.data=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                }, (err) => {
                    console.log(err);
                });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
   .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }  
</style>


// WEBPACK FOOTER //
// src/components/page/count/LevaeFlow.vue